import { getBinanceKLine } from 'api/v1/binance'
import {
  BINANCE_RESOLUTION_OPTIONS,
  ZKEX_SYMBOL_TO_BINANCE_API,
} from 'constants/chart'
import { TradeType } from 'store/market/types'
import { updateBinanceLastBar } from 'store/orderbook/actions'
import { binanceKLineArrayToObject } from 'utils/orderbook/order'
import { uuid } from 'utils/uuid'
import { store } from '../../store'

export enum SymbolName {
  wETH = 'wETH-USD',
  wBTC = 'wBTC-USD',
  wMATIC = 'wMATIC-USD',
  wAVAX = 'wAVAX-USD',
}

const binanceConnectionIdStoreKey = 'binance_ws_uuid'
export function connectionUniqueId() {
  const restore = window.sessionStorage.getItem(binanceConnectionIdStoreKey)
  if (restore) {
    return restore
  } else {
    const id = uuid()
    window.sessionStorage.setItem(binanceConnectionIdStoreKey, id)
    return id
  }
}

export class DataFeed {
  bars: any[] = []
  updateBars: any[] = []
  timer: any = null
  lastBar: number = 0
  unSubscribeLine: {
    [x: string]: any
  } = {}
  unSubscribeLastBar: any
  onReady(cb: any) {
    setTimeout(() => {
      cb({
        exchanges: [],
        symbols_types: [],
        supports_time: false,
        supported_resolutions: [1, 3, 5, 15, 30, 60, 120, 240, 360, 720, 1440],
        supports_marks: false,
        supports_timescale_marks: false,
      })
    }, 0)
  }
  resolveSymbol(
    symbolName: any,
    onSymbolResolvedCallback: any,
    onResolveErrorCallback: any,
  ) {
    const _store = store.getState()
    const _type = _store.market.trade
    let currentSymbol
    const market = _store.market.trades
    if (_type === TradeType.Perp) {
      const currentPerpSymbol = _store.perp.currentPerpSymbol
      currentSymbol = market.contractsSymbols.find(
        (v) => v.id === currentPerpSymbol,
      )
    } else {
      const currentSpotSymbol = _store.spot.currentSpotSymbol
      currentSymbol = market.spotsSymbols.find(
        (v) => v.id === currentSpotSymbol,
      )
    }
    const quoteScale = currentSymbol?.quoteScale ?? 2
    const pricescale = Math.pow(10, quoteScale)
    const data = {
      name: symbolName,
      has_intraday: true,
      has_daily: true,
      has_weekly_and_monthly: true,
      session: '24x7',
      pricescale,
      minmov: 1,
    }

    setTimeout(function () {
      onSymbolResolvedCallback(data)
    }, 0)
  }
  getBars(
    symbolInfo: any,
    resolution: any,
    periodParams: any,
    onHistoryCallback: any,
    onErrorCallback: any,
  ) {
    const interval = BINANCE_RESOLUTION_OPTIONS[resolution]
    this.bars = []
    const _store = store.getState()
    const _type = _store.market.trade
    const exchange =
      _type === TradeType.Perp ? 'binance:contract' : 'binance:spot'
    getBinanceKLine({
      symbol: ZKEX_SYMBOL_TO_BINANCE_API[symbolInfo.name],
      interval,
      startTime: periodParams.from * 1000,
      endTime: periodParams.to * 1000,
      exchange,
    })
      .then((r) => r.data)
      .then((r) => {
        if (r?.data?.length > 0) {
          const bars = binanceKLineArrayToObject(r.data)
          this.lastBar = bars[bars.length - 1]?.time
          if (periodParams.firstDataRequest) {
            this.bars = bars || []
          }
          onHistoryCallback(bars)
        } else {
          onHistoryCallback([], { noData: true })
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
  subscribeBars(
    symbolInfo: any,
    resolution: any,
    onRealtimeCallback: any,
    subscriberUID: any,
    onResetCacheNeededCallback: any,
  ) {
    store.dispatch(updateBinanceLastBar({}))

    this.bars?.length > 1 && onRealtimeCallback(this.bars[this.bars.length - 1])

    function handleChangeLastBar() {
      const currentValue = store.getState().orderbook.binanceLastBar
      
      const unFreezeCurrentValue = { ...currentValue }
      currentValue?.time && onRealtimeCallback(unFreezeCurrentValue)
    }
    !this.unSubscribeLastBar && (this.unSubscribeLastBar = {})
    this.unSubscribeLastBar[subscriberUID] =
      store.subscribe(handleChangeLastBar)
  }
  unsubscribeBars(subscriberUID: any) {
    this.unSubscribeLastBar[subscriberUID]()
  }
}
